import {
  TeamManager,
  PollsManager,
  StageManager,
  JournalManager,
  EventManager,
  EventTemplatesManager,
  EventTemplatesConfigManager,
  QuotaManager,
  NominationsManager,
  SubordinationManager,
  AddressesManager,
  ExpertiseCriteriaManager,
  ExhibitionsManager,
  LevelDocumentsManager,
  AdminEventTemplatesManager,
  EventAssociationsManager,
  EventAnnouncementsManager,
  ExpertiseManager,
  UsersManager,
  ExpertManager,
  AuthManager,
  GroupManager,
  TaskManager,
  TournamentManager,
  UploadManager,
  QuestionTagManager,
  QuestionManager,
  ExchangeManager,
} from '@/models/index';

export const MODELS = {
  team: TeamManager,
  poll: PollsManager,
  journal: JournalManager,
  stage: StageManager,
  event: EventManager,
  expertise: ExpertiseManager,
  eventTemplates: EventTemplatesManager,
  eventTemplatesConfig: EventTemplatesConfigManager,
  quota: QuotaManager,
  nomination: NominationsManager,
  subordination: SubordinationManager,
  addresses: AddressesManager,
  expertiseCriteria: ExpertiseCriteriaManager,
  exhibitions: ExhibitionsManager,
  levelDocuments: LevelDocumentsManager,
  adminEventTemplates: AdminEventTemplatesManager,
  eventAssociations: EventAssociationsManager,
  eventAnnouncements: EventAnnouncementsManager,
  users: UsersManager,
  expert: ExpertManager,
  auth: AuthManager,
  group: GroupManager,
  task: TaskManager,
  tournament: TournamentManager,
  upload: UploadManager,
  questionTag: QuestionTagManager,
  question: QuestionManager,
  exchange: ExchangeManager,
};

const Api = {
  install: (Vue) => {
    Vue.models = MODELS;
    Vue.prototype.$models = MODELS;
  },
};

export default Api;
